export default "assets/images/menu-507b205c.jpg";